// #region Developer Information
/*
 ********************************************
  Author: Andrew Laychak
  Email: ALaychak@HarrisComputer.com

  Created At: 10-23-2024 08:12:30 PM
  Last Modified: 10-28-2024 04:50:25 PM
  Last Updated By: Andrew Laychak

  Description: Checks and configures the REST API URL based on the environment.

  References:
    - None
 ********************************************
*/
// #endregion

// #region Imports
import { environment } from 'src/environments/environment';
// #endregion

function getRestEndpoint() {
  const isPr = window.location.hostname.startsWith('pr-');
  if (!isPr) {
    return environment.apiUrl;
  }

  const { hostname, protocol, port } = window.location;

  const apiUrl = new URL(environment.apiUrl);
  const path = apiUrl.pathname;

  const parts = hostname.split('.');

  if (parts.length > 1) {
    parts[1] = parts[1].replace(environment.appPrefix, environment.apiPrefix);
  }
  const modifiedHostname = parts.join('.');

  return `${protocol}//${modifiedHostname}${port ? `:${port}` : ''}${path}`;
}

// #region Exports
export { getRestEndpoint };
// #endregion
